import { call, fork, put, take } from 'typed-redux-saga'
import {
	channelHandlerFactory,
	socketSlice,
	SocketMessage,
	SocketMessageTypes,
	MessageCode,
	AppSocketType,
	WorkerMessageData,
} from 'Modules/Socket'
import { END, EventChannel, eventChannel } from 'redux-saga'
import { Callback } from 'Src/types/utilTypes'
import { Deserialize } from 'cerialize'
import { Action } from 'Types/action'
import { getClientBaseUrl } from '@pp/axios'
import { Logger } from 'Modules'
import { reconnectPingWatcherSaga } from './reconnectPingWatcherSaga'
import { createWsConnection } from './createWsConnectionSaga'

function* watcherChannel(channel: EventChannel<unknown>) {
	while (true) {
		const channelAction = yield* take(channel)
		yield* put(channelAction as Action<unknown>)
	}
}

export function* createWorker() {
	yield* put(socketSlice.actions.setHasWorker(true))

	yield* call(async () =>
		navigator.serviceWorker
			.register(new URL('../../helpers/ws-service.worker', import.meta.url), {
				scope: '/',
			})
			.then((reg) => {
				Logger.info('ServiceWorker scope:', reg.scope)
			})
	)
	yield* call(async () => {
		navigator.serviceWorker.getRegistrations().then((regs) => {
			regs.forEach((reg) => {
				if (reg.scope !== `${getClientBaseUrl()}/`) {
					reg.unregister()
				}
			})
		})
	})

	const controller = yield* call(async () => navigator.serviceWorker.controller)

	if (!controller) {
		window.location.reload()
	} else {
		navigator.serviceWorker.addEventListener('controllerchange', () => {})
	}

	const channel = eventChannel((dispatch: Callback) => {
		const runHandler = channelHandlerFactory(dispatch)

		const handler = (e: MessageEvent<WorkerMessageData<string>>) => {
			if (e.data.appSocketType === AppSocketType.NEO) {
				const data = Deserialize(JSON.parse(e?.data.data.payload), SocketMessage)
				if (data.type === SocketMessageTypes.PING) {
					dispatch(socketSlice.actions.setCurrentPing(data.message))
				}

				if (data.type === SocketMessageTypes.WELCOME) {
					dispatch(socketSlice.actions.subscribeChannels([]))
				}

				if (data === MessageCode.CLOSE) {
					navigator.serviceWorker.removeEventListener('message', handler)
					dispatch(END)
					return
				}

				runHandler(data)
			}
		}

		navigator.serviceWorker.addEventListener('message', handler)

		return () => dispatch(END)
	})

	yield* call(createWsConnection)
	yield* fork(reconnectPingWatcherSaga)
	yield* call(watcherChannel, channel)
}
